let _initProto, _initClass, _init_value, _init_extra_value, _init_min, _init_extra_min, _init_max, _init_extra_max, _init_disabled, _init_extra_disabled, _init_readOnly, _init_extra_readOnly, _init_label, _init_extra_label, _init_name, _init_extra_name, _init_placeholder, _init_extra_placeholder, _init_locale, _init_extra_locale, _init_dateStyle, _init_extra_dateStyle, _init_masked, _init_extra_masked, _init_visibleMonths, _init_extra_visibleMonths, _init_changeEvent, _init_extra_changeEvent, _init_displayValue, _init_extra_displayValue, _init_editing, _init_extra_editing, _init_open, _init_extra_open, _init_popoverTarget, _init_extra_popoverTarget;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, customElement, event, onEvent, onUpdated, prop, query, state } from "@ecopages/radiant";
import { dateToIso, formatDisplayDate, isoToDate, parseLocaleDateString } from "@/lib/intl-date";
import { resolveLocale } from "@/lib/intl/locale";
import { PopoverController, shouldDismissPopoverFocus } from "../shared/popover-controller";
import { syncFieldLabel } from "../shared/field-label";
import { applyDateMask, buildDateMaskPattern, extractDateMaskDigits, getDefaultDatePlaceholder, getNumericPartOrder, maskDigitCapacity } from "@/lib/mask";
let _RuiDateField;
class RuiDateField extends RadiantElement {
  static {
    ({
      e: [_init_value, _init_extra_value, _init_min, _init_extra_min, _init_max, _init_extra_max, _init_disabled, _init_extra_disabled, _init_readOnly, _init_extra_readOnly, _init_label, _init_extra_label, _init_name, _init_extra_name, _init_placeholder, _init_extra_placeholder, _init_locale, _init_extra_locale, _init_dateStyle, _init_extra_dateStyle, _init_masked, _init_extra_masked, _init_visibleMonths, _init_extra_visibleMonths, _init_changeEvent, _init_extra_changeEvent, _init_displayValue, _init_extra_displayValue, _init_editing, _init_extra_editing, _init_open, _init_extra_open, _init_popoverTarget, _init_extra_popoverTarget, _initProto],
      c: [_RuiDateField, _initClass]
    } = _applyDecs(this, [customElement("rui-date-field")], [[prop({
      type: String,
      reflect: true,
      defaultValue: ""
    }), 0, "value"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "min"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "max"], [prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "disabled"], [prop({
      type: Boolean,
      attribute: "read-only",
      reflect: true,
      defaultValue: false
    }), 0, "readOnly"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "label"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "name"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "placeholder"], [prop({
      type: String,
      defaultValue: ""
    }), 0, "locale"], [prop({
      type: String,
      attribute: "date-style",
      defaultValue: "medium"
    }), 0, "dateStyle"], [prop({
      type: Boolean,
      reflect: true,
      defaultValue: true
    }), 0, "masked"], [prop({
      type: Number,
      attribute: "visible-months",
      defaultValue: 1
    }), 0, "visibleMonths"], [event({
      name: "rui-change",
      bubbles: true,
      composed: true
    }), 0, "changeEvent"], [state, 0, "displayValue"], [state, 0, "editing"], [state, 0, "open"], [query({
      ref: "popover"
    }), 0, "popoverTarget"], [onUpdated(["value", "min", "max", "label", "placeholder", "disabled", "readOnly", "locale", "dateStyle", "masked", "visibleMonths"]), 2, "onPropsUpdated"], [onUpdated(["open"]), 2, "onOpenUpdated"], [onEvent({
      selector: "[data-date-field-input]",
      type: "focusin"
    }), 2, "onInputFocus"], [onEvent({
      selector: "[data-date-field-input]",
      type: "input"
    }), 2, "onInput"], [onEvent({
      selector: "[data-date-field-input]",
      type: "change"
    }), 2, "onInputChange"], [onEvent({
      selector: "[data-date-field-input]",
      type: "keydown"
    }), 2, "onInputKeydown"], [onEvent({
      selector: "[data-date-field-input], [data-date-field-trigger], [data-date-field-popover]",
      type: "focusout"
    }), 2, "onRootFocusOut"], [onEvent({
      ref: "trigger",
      type: "pointerdown"
    }), 2, "onTriggerPointerDown"], [onEvent({
      ref: "trigger",
      type: "click"
    }), 2, "onTriggerClick"], [onEvent({
      selector: "[data-date-field-popover]",
      type: "mousedown"
    }), 2, "onPopoverMouseDown"], [onEvent({
      selector: "[data-date-field-calendar]",
      type: "rui-change"
    }), 2, "onCalendarChange"], [onEvent({
      selector: "[data-date-field-input], [data-date-field-trigger], [data-date-field-calendar]",
      type: "keydown"
    }), 2, "onRootKeydown"]], 0, void 0, RadiantElement));
  }
  constructor(...args) {
    super(...args);
    _init_extra_popoverTarget(this);
  }
  value = (_initProto(this), _init_value(this));
  min = (_init_extra_value(this), _init_min(this));
  max = (_init_extra_min(this), _init_max(this));
  disabled = (_init_extra_max(this), _init_disabled(this));
  readOnly = (_init_extra_disabled(this), _init_readOnly(this));
  label = (_init_extra_readOnly(this), _init_label(this));
  name = (_init_extra_label(this), _init_name(this));
  placeholder = (_init_extra_name(this), _init_placeholder(this));
  locale = (_init_extra_placeholder(this), _init_locale(this));
  dateStyle = (_init_extra_locale(this), _init_dateStyle(this));
  masked = (_init_extra_dateStyle(this), _init_masked(this));
  visibleMonths = (_init_extra_masked(this), _init_visibleMonths(this));
  changeEvent = (_init_extra_visibleMonths(this), _init_changeEvent(this));
  displayValue = (_init_extra_changeEvent(this), _init_displayValue(this, ""));
  editing = (_init_extra_displayValue(this), _init_editing(this, false));
  open = (_init_extra_editing(this), _init_open(this, false));
  uid = (_init_extra_open(this), Math.random().toString(36).slice(2, 9));
  popoverController = null;
  suppressPopoverDismiss = false;
  popoverTarget = _init_popoverTarget(this);
  get isoValue() {
    return this.value ?? "";
  }
  get resolvedLocale() {
    return resolveLocale(this.locale);
  }
  get inputId() {
    return `rui-date-field-input-${this.uid}`;
  }
  get resolvedPlaceholder() {
    return this.placeholder || getDefaultDatePlaceholder(this.resolvedLocale);
  }
  getInput() {
    return this.querySelector("[data-date-field-input]");
  }
  getToggle() {
    return this.querySelector("[data-date-field-trigger]");
  }
  getCalendar() {
    return this.querySelector("[data-date-field-calendar]");
  }
  syncLabel() {
    const input = this.getInput();
    syncFieldLabel(this, input, {
      controlId: this.inputId,
      label: this.label,
      labelId: `rui-date-field-label-${this.uid}`
    });
  }
  syncInput() {
    const input = this.getInput();
    if (!input) {
      return;
    }
    if (!input.id) {
      input.id = this.inputId;
    }
    input.name = this.name;
    input.disabled = this.disabled;
    input.readOnly = this.readOnly;
    input.inputMode = this.masked ? "numeric" : "text";
    const placeholder = this.resolvedPlaceholder;
    if (placeholder) {
      input.placeholder = placeholder;
    }
  }
  syncToggle() {
    const toggle = this.getToggle();
    if (!toggle) {
      return;
    }
    toggle.disabled = this.disabled || this.readOnly;
    toggle.setAttribute("aria-expanded", String(this.open));
  }
  syncCalendar() {
    const calendar = this.getCalendar();
    if (!calendar) {
      return;
    }
    calendar.setAttribute("selection-mode", "single");
    calendar.setAttribute("visible-months", String(this.visibleMonths));
    calendar.setAttribute("value", this.isoValue);
    calendar.setAttribute("min", this.min);
    calendar.setAttribute("max", this.max);
    calendar.setAttribute("locale", this.locale);
    calendar.toggleAttribute("disabled", this.disabled);
  }
  formatForDisplay(iso) {
    if (!iso) {
      return "";
    }
    const date = isoToDate(iso);
    if (!date) {
      return "";
    }
    return formatDisplayDate(date, this.resolvedLocale, this.dateStyle);
  }
  formatForEditing(iso) {
    if (!iso) {
      return "";
    }
    if (!this.masked) {
      return this.formatForDisplay(iso);
    }
    const date = isoToDate(iso);
    if (!date) {
      return "";
    }
    const pattern = buildDateMaskPattern(this.resolvedLocale);
    const digits = dateToMaskDigits(date, this.resolvedLocale);
    return applyDateMask(digits, pattern);
  }
  syncDisplayValue() {
    if (this.editing) {
      return;
    }
    this.displayValue = this.formatForDisplay(this.isoValue);
    const input = this.getInput();
    if (input) {
      input.value = this.displayValue;
    }
  }
  isIsoAllowed(iso) {
    if (this.min && iso < this.min) {
      return false;
    }
    if (this.max && iso > this.max) {
      return false;
    }
    return true;
  }
  commitValue(iso) {
    if (iso && !this.isIsoAllowed(iso)) {
      this.syncDisplayValue();
      return;
    }
    if (iso === this.isoValue) {
      this.syncDisplayValue();
      return;
    }
    this.value = iso;
    this.changeEvent.emit({
      value: iso
    });
    this.syncDisplayValue();
  }
  parseAndCommit(raw) {
    const trimmed = (raw ?? "").trim();
    if (!trimmed) {
      this.commitValue("");
      return;
    }
    const parsed = parseLocaleDateString(trimmed, this.resolvedLocale);
    if (!parsed) {
      this.syncDisplayValue();
      return;
    }
    this.commitValue(dateToIso(parsed));
  }
  handleMaskedInput(raw) {
    const pattern = buildDateMaskPattern(this.resolvedLocale);
    const digits = extractDateMaskDigits(raw);
    const masked = applyDateMask(digits, pattern);
    if (digits.length >= maskDigitCapacity(pattern)) {
      this.parseAndCommit(masked);
    }
    return masked;
  }
  initialize() {
    this.syncLabel();
    this.syncInput();
    this.syncDisplayValue();
    this.syncToggle();
    this.syncCalendar();
    this.setOpen(false);
  }
  setOpen(next) {
    this.open = next;
    queueMicrotask(() => {
      this.syncCalendar();
      this.syncPopoverPosition();
      if (next) {
        this.focusCalendarDay();
      }
    });
  }
  /** Focus the calendar's roving day, falling back to its first available day. */
  focusCalendarDay() {
    requestAnimationFrame(() => {
      if (!this.open) {
        return;
      }
      const calendar = this.getCalendar();
      const selectedDay = this.isoValue ? calendar?.querySelector(`[data-calendar-day][data-iso="${this.isoValue}"]:not(:disabled)`) : null;
      (selectedDay ?? calendar?.querySelector('[data-calendar-day][tabindex="0"]:not(:disabled), [data-calendar-day]:not(:disabled)'))?.focus();
    });
  }
  ensurePopoverController() {
    if (!this.popoverController) {
      this.popoverController = new PopoverController({
        getAnchor: () => this.getToggle()?.parentElement ?? this,
        getFloating: () => this.popoverTarget,
        getOpen: () => this.open,
        getPlacement: () => "bottom-start",
        gap: 4,
        portal: false
      });
    }
    return this.popoverController;
  }
  syncPopoverPosition() {
    const popover = this.popoverTarget;
    if (!popover) {
      return;
    }
    popover.hidden = !this.open;
    const controller = this.ensurePopoverController();
    controller.updateConfig({
      getOpen: () => this.open
    });
    controller.sync();
  }
  onConnected() {
    this.initialize();
  }
  disconnectedCallback() {
    this.popoverController?.destroy();
    this.popoverController = null;
    super.disconnectedCallback();
  }
  onPropsUpdated() {
    this.syncLabel();
    this.syncInput();
    this.syncDisplayValue();
    this.syncToggle();
    this.syncCalendar();
  }
  onOpenUpdated() {
    this.syncToggle();
    this.syncPopoverPosition();
  }
  onInputFocus() {
    this.editing = true;
    const input = this.getInput();
    if (!input) {
      return;
    }
    input.value = this.isoValue ? this.formatForEditing(this.isoValue) : "";
    this.displayValue = input.value;
  }
  onInput(event2) {
    const input = event2.target;
    if (this.masked) {
      const masked = this.handleMaskedInput(input.value);
      input.value = masked;
      this.displayValue = masked;
      return;
    }
    this.displayValue = input.value;
  }
  onInputChange() {
    const input = this.getInput();
    if (input) {
      this.parseAndCommit(input.value);
    }
  }
  onInputKeydown(event2) {
    if (event2.key === "Escape") {
      if (this.open) {
        event2.preventDefault();
        this.setOpen(false);
        return;
      }
      this.editing = false;
      this.syncDisplayValue();
    }
  }
  onRootFocusOut(event2) {
    const target = event2.target;
    const relatedTarget = event2.relatedTarget;
    if (target.matches("[data-date-field-input]") && target.localName === "input") {
      const input = target;
      queueMicrotask(() => {
        if (!this.editing) {
          return;
        }
        this.editing = false;
        this.parseAndCommit(input.value);
      });
    }
    queueMicrotask(() => {
      if (this.suppressPopoverDismiss) {
        this.suppressPopoverDismiss = false;
        return;
      }
      if (!this.open) {
        return;
      }
      const next = relatedTarget instanceof Node ? relatedTarget : document.activeElement;
      if (!shouldDismissPopoverFocus(this, this.popoverTarget, next)) {
        return;
      }
      this.setOpen(false);
    });
  }
  onTriggerPointerDown() {
    this.suppressPopoverDismiss = true;
  }
  onTriggerClick() {
    if (this.disabled || this.readOnly) {
      return;
    }
    this.setOpen(!this.open);
  }
  onPopoverMouseDown(event2) {
    event2.preventDefault();
  }
  onCalendarChange(event2) {
    const target = event2.target;
    if (!(target instanceof HTMLElement) || !target.matches("[data-date-field-calendar]")) {
      return;
    }
    const detail = event2.detail;
    if (!detail?.value) {
      return;
    }
    this.commitValue(detail.value);
    this.setOpen(false);
  }
  onRootKeydown(event2) {
    if (event2.key === "Escape" && this.open) {
      event2.preventDefault();
      this.setOpen(false);
    }
  }
  static {
    _initClass();
  }
}
export { _RuiDateField as RuiDateField };
function dateToMaskDigits(date, locale) {
  const order = getNumericPartOrder(locale);
  const values = {
    month: String(date.getMonth() + 1).padStart(2, "0"),
    day: String(date.getDate()).padStart(2, "0"),
    year: String(date.getFullYear())
  };
  return order.map(part => values[part]).join("");
}